import React, { useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { Collection } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import FavouriteGameEditor from '../edit/FavouriteGameEditor';
import GameTypeBadge from '../../../../GameTypeBadge';

function FavouriteGameDisplayer(props) {
    const { t } = useTranslation('messages');
    const [showEditGame, setShowEditGame] = useState(false);
    const [underEditGame, setUnderEditGame] = useState(null);
    const [underAssociationLabelsMap, setUnderAssociationLabelsMap] = useState(new Map());

    if (props.favouriteGames.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <Collection size={48} className="mb-3 opacity-25" />
                <p className="mb-0">{t('private_area.games_tab.empty_state')}</p>
            </div>
        );
    }

    return (
        <>
            <div>
                {props.favouriteGames.map((game) => (
                    <div key={game.favouriteGameId} className="card border-0 shadow-sm mb-3">
                        <div id={game.name.charAt(0)} />
                        <div className="card-body p-3 d-flex gap-3 align-items-start">
                            {game.imageLink && (
                                <img
                                    src={game.imageLink}
                                    alt={game.name}
                                    className="rounded flex-shrink-0"
                                    style={{ width: 72, height: 72, objectFit: 'cover' }}
                                />
                            )}
                            <div className="flex-grow-1 min-w-0">
                                <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                    <a
                                        href={game.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="fw-semibold text-dark text-decoration-none"
                                    >
                                        {game.name}
                                    </a>
                                    <GameTypeBadge gameType={game.gameType} />
                                </div>
                                {game.description && (
                                    <p className="text-clamp text-muted small mb-2 mt-1">
                                        {game.description}
                                    </p>
                                )}
                                {game.gameLabels && game.gameLabels.length > 0 && (
                                    <div className="d-flex flex-wrap gap-1 mb-2">
                                        {game.gameLabels.map((label) => (
                                            <Badge key={label.gameLabelId} bg="secondary">{label.name}</Badge>
                                        ))}
                                    </div>
                                )}
                                <div className="d-flex flex-wrap gap-2 align-items-center mt-1">
                                    <span className="text-muted small">
                                        {game.creationTime ? new Date(game.creationTime).toLocaleDateString() : ''}
                                    </span>
                                    <span className="text-muted small">
                                        {game.lastPlayedAt
                                            ? new Date(game.lastPlayedAt).toLocaleDateString()
                                            : t('private_area.games_tab.last_played_at_never')}
                                    </span>
                                </div>
                                <div className="d-flex flex-wrap gap-2 mt-2">
                                    <Button size="sm" variant="outline-primary"
                                        onClick={() => onShowGameEditor(game, setShowEditGame, setUnderEditGame, setUnderAssociationLabelsMap)}>
                                        {t('private_area.games_tab.games_edit_button_text')}
                                    </Button>
                                    <Button size="sm" variant="outline-secondary"
                                        onClick={() => props.onSearchProductClicked(game.name)}>
                                        {t('private_area.games_tab.games_serch_button_text')}
                                    </Button>
                                    <Button size="sm" variant="outline-danger"
                                        onClick={() => props.deleteGame(game.favouriteGameId)}>
                                        {t('private_area.games_tab.games_delete_button_text')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <FavouriteGameEditor
                gameLabels={props.gameLabels}
                associateLabels={props.associateLabels}
                showEditGame={showEditGame}
                underAssociationLabelsMap={underAssociationLabelsMap}
                setUnderAssociationLabelsMap={setUnderAssociationLabelsMap}
                underEditGame={underEditGame}
                onCloseGameEditor={() => onCloseGameEditor(setShowEditGame, setUnderEditGame, setUnderAssociationLabelsMap)}
            />
        </>
    );
}

function onShowGameEditor(game, setShowEditGame, setUnderEditGame, setUnderAssociationLabelsMap) {
    setShowEditGame(true);
    setUnderEditGame(game);
    let map = game.gameLabels.reduce((map, gameLabel) => {
        map.set(gameLabel.gameLabelId, true);
        return map;
    }, new Map());
    setUnderAssociationLabelsMap(map);
}

function onCloseGameEditor(setShowEditGame, setUnderEditGame, setUnderAssociationLabelsMap) {
    setShowEditGame(false);
    setUnderEditGame(null);
    setUnderAssociationLabelsMap(new Map());
}

export default FavouriteGameDisplayer;
